
const TermsOfUse = () => import('@/views/controller/terms/TermsOfUse.vue')
const PrivacyPolicies = () => import('@/views/controller/terms/PrivacyPolicies.vue')

export default [
    { path: 'termos-de-uso', name: 'controller.terms.of.use', component: TermsOfUse, meta: { title: 'Termos de uso', permission: 2 } },
    { path: 'politicas-de-privacidade', name: 'controller.privacy.policies', component: PrivacyPolicies, meta: { title: 'Políticas de privacidade', permission: 2 } },
]